import React from 'react';
import {
	SdfBox,
	SdfQuickStat,
	SdfRadioButton,
	SdfSpotIllustration
} from '@synerg/react-components';

function StepTwo({ state, useCases, selectedUseCaseBtnIndex, setSelectedUseCaseBtnIndex, setValue }) {
	const { companySize = 'mid', appStore } = state;
	const thisUseCases = useCases.filter(({ locale, hideIndicator, sizes }) => 
		sizes.includes(companySize || 'mid') && !hideIndicator && locale === appStore
	);

	const lc = text => (text || '').toLowerCase();
	let displayUseCases = thisUseCases;
	displayUseCases.sort((a, b) => {
		const isOtherTransformation = t => t.indexOf('other') === 0 ? 'zzzzzzzzz' : t;
		const at = isOtherTransformation(lc(a.title));
		const bt = isOtherTransformation(lc(b.title));
		if (at < bt) { return -1; }
		if (at === bt) { return 0; }
		return 1;
	});

	function getIllustrationByCategory(category) {
		switch (category) {
		case 'benefits':
			return 'health-crest';
		case 'benefits administration':
			return 'heart-hands';
		case 'compliance':
			return 'clipboard';
		case 'empIncomeVerification':
			return 'magnifying-glass-recruiter';
		case 'learning management':
			return 'certificate';
		case 'other':
			return 'shield';
		case 'productivity & collaboration':
			return 'high-five';
		case 'performance':
			return 'trophy';
		case 'payroll':
			return 'money-hand';
		case 'retention':
			return 'connections';
		case 'recruiting':
			return 'people-3';
		case 'time':
			return 'time-sheets';
		default:
			return 'warning';
		}
	}

	return (<div>
		<div className="mt-8">
			<span className="text-heading-05 font-bold mb-4	">Use case selection</span>
			<p className="text-body-02 mb-6">Select a use case that best describes
				the type of data you need for your integration.</p>
			<span className="text-heading-05 font-bold">Which data set best fits your integration use case?</span>

			<div className="mt-8 overflow-y-scroll p-1 max-w-3xl" style={{height: "24rem"}}>
				<section data-cvs-id="appStore-US" className="items-center justify-center	grid grid-cols-3 gap-4">
					{displayUseCases && displayUseCases.map(({ _id: id, title, description, category }, index) => (
						<SdfBox
							style={{height: '270px'}}
							variant="bordered"
							spacing="default"
							className="justify-center min-h-24 max-h-30 w-60"
							key={index}
							onClick={() => {
								//add use case id and user case name
								setSelectedUseCaseBtnIndex(index);
								setValue('useCaseID', id);
								setValue('useCaseName', title);
							}}
						>
							<SdfQuickStat	size="md">
								<div className="flex text-sm">
									<SdfRadioButton value="US" checked={index === selectedUseCaseBtnIndex}/>
								</div>
							</SdfQuickStat>
							<div className="flex flex-col items-center overflow-hidden px-2">
								<SdfSpotIllustration
									illustrationName={getIllustrationByCategory(category)}
									size={'sm'}
								/>
								<div className="text-heading-04 font-bold text-center capitalize mt-2">{title}</div>
							</div>
						</SdfBox>
					))}
				</section>
			</div>

		</div>
	</div>);
}

export default StepTwo;
